<template>
  <div class="container">
    <div>
      <img id="AppIcon" alt="Graph Editor App Icon" src="@/assets/GraphEditor/GraphEditorAppIcon.jpg">
    </div>
    <div id="AppTitle">
      <label>Graph Editor</label>
    </div>
    <div id="author">
      <label>askrsw</label>
    </div>
    <div id="email">
      <label>askrsw@163.com</label>
    </div>
    <div id="appPreviewRow">
      <div class="appScreenShot">
        <img src="@/assets/GraphEditor/GraphEditorPicture1.jpg" />
      </div>
      <div class="appScreenShot">
        <img src="@/assets/GraphEditor/GraphEditorPicture2.jpg" />
      </div>
      <div class="appScreenShot">
        <img src="@/assets/GraphEditor/GraphEditorPicture3.jpg" />
      </div>
      <div class="clear"></div>
    </div>
    <div id="text">
      <p>The best app for you to build and edit graph.</p>
    </div>
    <div>
      <img alt="Apple App Icon" src="@/assets/common/downloadfromappstore.png">
    </div>
    <div id="location">
      <label>Shandong, China</label>
    </div>
    <div id="copyright">
      <label>Copyright &copy; 2022 Haharsw</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GraphEditor'
}
</script>

<style scoped>
.container {
  text-align: center;
}
#AppIcon {
  width: 160px;
  height: 160px;
  border-radius: 15px;
}
#AppTitle {
  font-weight: bold;
  font-size: 22px;
  margin-top: 20px;
  margin-bottom: 10px;
}
#author {
  font-weight: normal;
  font-size: 22px;
  margin-top: 10px;
}
#email {
  font-weight: normal;
  font-size: 18px;
  margin-top: 0px;
}
#text {
  margin: 0 auto;
  font-weight: normal;
  font-size: 20px;
  margin-top: 40px;
  margin-bottom: 20px;
  max-width: 800px;
}
#text p {
  margin: 0 auto;
}
#appPreviewRow {
  margin: 0 auto;
  margin-top: 30px;
  max-width: 1024px;
  float: none;
}
.appScreenShot {
  float: left;
  width: 33%;
}
.appScreenShot img{
  width: 90%;
  margin-left: 5%;
  margin-right: 5%;
  border-radius: 10px;
}
.clear{ clear:both}
#location {
  font-weight: normal;
  font-size: 16px;
  margin-top: 60px;
  margin-bottom: 10px;
}
#copyright {
  font-weight: normal;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 40px;
}
</style>
